import apiActionsMagazine from '@/api/actions-magazine'

const state = {
  data: [],
  total: null,
  isLoading: false,
  error: null,
}

export const mutationTypes = {
  getActionsMagazineByParamsStart:
    '[actions-magazine list] Get actions-magazine by params start',
  getActionsMagazineByParamsSuccess:
    '[actions-magazine list] Get actions-magazine by params success',
  getActionsMagazineByParamsFailure:
    '[actions-magazine list] Get actions-magazine by params failure',
}

export const actionTypes = {
  getActionsMagazineByParams:
    '[actions-magazine list] Get actions-magazine by params',
}

const mutations = {
  [mutationTypes.getActionsMagazineByParamsStart](state) {
    state.isLoading = true
    state.data = []
  },

  [mutationTypes.getActionsMagazineByParamsSuccess](state, payload) {
    state.data = payload.data ? payload.data : payload
    state.total = payload.total ? payload.total : 0
    state.isLoading = false
  },

  [mutationTypes.getActionsMagazineByParamsFailure](state) {
    state.isLoading = false
  },
}

const actions = {
  [actionTypes.getActionsMagazineByParams](context, {params}) {
    context.commit(mutationTypes.getActionsMagazineByParamsStart)
    return new Promise((resolve) => {
      apiActionsMagazine
        .getActionsMagazineByParams(params)
        .then((response) => {
          const actionsMagazine = response.data ? response.data : response
          context.commit(
            mutationTypes.getActionsMagazineByParamsSuccess,
            response
          )
          resolve(actionsMagazine)
        })
        .catch(() => {
          context.commit(mutationTypes.getActionsMagazineByParamsFailure)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
